import UpcomingMeetingsRepo from "@adapters/salesFeatures/Homepage/repositories/eventsActivities/upcomingMeetings";
import UpcomingEventsRepository from "@adapters/salesFeatures/Homepage/repositories/eventsActivities/upcomingEvents";
import ExpiringLeadsRepo from "@adapters/salesFeatures/Homepage/repositories/eventsActivities/expiringLeads";
import EngagementDashboardRepo from "@adapters/salesFeatures/Homepage/repositories/engagementDashboard";
import EngagementDashboardStatus from "@adapters/salesFeatures/Homepage/repositories/engagementDashboardStatus";
import DownloadHomePageRepo from "@adapters/salesFeatures/Homepage/repositories/DownloadHomePageRepo";
export default (function (http) {
    return {
        eventActivities: {
            upcomingMeetings: new UpcomingMeetingsRepo(http),
            upcomingEvents: new UpcomingEventsRepository(http),
            expiringLeads: new ExpiringLeadsRepo(http),
        },
        engagementDashboard: new EngagementDashboardRepo(http),
        engagementDashboardStatus: new EngagementDashboardStatus(http),
        downloadHomeData: new DownloadHomePageRepo(http),
    };
});
